import { useState } from "react";
import { HiOutlineCheck, HiOutlineXMark } from "react-icons/hi2";
import Button from "@/components/Button";
import usePermission from "../../../../hooks/usePermission";
import { useUpdateQuizConfig } from "../hooks/useUpdateQuizConfig";
import { useParams } from "react-router-dom";

function QuizDetal({ isSuccess, quizConfig: {
    quizAttemptLimit,
    attemptCount,
    realSubmits,
    id
} }) {
    const { userId, courseId, lectureId } = useParams();
    const [startEdit, setStartEdit] = useState(false);
    const [maxAttemptsCount, setMaxAttemptsCount] = useState(0);
    const { can } = usePermission();
    function handelMaxAttemptsCountChange(e) {
        if (maxAttemptsCount !== e.target.value)
            setMaxAttemptsCount(e.target.value);
    }
    const { updateQuizConfig } = useUpdateQuizConfig()
    function onSubmit() {
        updateQuizConfig(
            { userId, courseId, quizId: id, lectureId, max_attempts: maxAttemptsCount },
            {
                onSuccess: () => {
                    setStartEdit(false);
                },
            })
    }
    return (
        <div className="flex flex-col justify-between h-full">
            <div className="flex flex-col gap-4">
                <div className="flex items-center gap-5">
                    <p>- نجح في الأختبار :</p>
                    {isSuccess ? (
                        <span className="p-2 bg-green-500 rounded-full">
                            <HiOutlineCheck className="text-lg font-extrabold text-white" />
                        </span>
                    ) : (
                        <span className="inline-block p-1 bg-red-500 rounded-full w-fit">
                            <HiOutlineXMark className="text-lg font-extrabold text-white" />
                        </span>
                    )}
                </div>
                <p>
                    - عدد مرات تسليم الأمتحان :
                    <span className="px-1 text-gray-color-primary">{realSubmits}</span>
                </p>
                <p>
                    - عدد مرات دخول الأمتحان :
                    <span className="px-1 text-gray-color-primary">{attemptCount}</span>
                </p>
            </div>
            <div>
                <label>- تحديد عدد المحاولات:</label>
                {!quizAttemptLimit && <span> غير محدود</span>}
                {quizAttemptLimit && startEdit && <input
                    className={`mx-3 mt-3 leading-7 text-center border-2 rounded-lg outline-none w-14 border-gray-color-primary focus:border-primary-color-primary ${!startEdit && "bg-gray-300"
                        }`}
                    defaultValue={0}
                    type="number"
                    disabled={!startEdit}
                    onChange={handelMaxAttemptsCountChange}
                />}
            </div>
            {quizAttemptLimit && <>
                {!startEdit && can("update:course:lecture:quiz:views") && (
                    <Button type="primary" onClick={() => setStartEdit(true)}>
                        اضافه
                    </Button>
                )}
                {startEdit && can("update:course:lecture:quiz:views") && <Button disabled={!maxAttemptsCount}  type="primary" onClick={onSubmit}>حفظ التعديل</Button>}
            </>}
        </div>
    );
}

export default QuizDetal;
